<template>
  <div class="login-container main-container">
    <img src="@/static/img/chain/evm_banner.jpg" width="100%" />
    <div class="info">
      <h1>{{ $t("webwallet_your") }}</h1>
      <p>{{ $t("webwallet_home_des") }}</p>
      <div>
        <a @click="login" :class="['btn', { disabled: loading }]">{{
          $t("webwallet_login")
        }}</a>
      </div>
      <div class="ledger-login">
        <a @click="ledgerLogin" :class="['btn', { disabled: ledgerLoading }]">{{
          $t("ledger_login")
        }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
import Eth from "@ledgerhq/hw-app-eth";
export default {
  data() {
    return {
      loading: false,
      ledgerLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      chainList: "chainList",
    }),
  },
  methods: {
    ...mapActions(["setAccount"]),
    login() {
      this.loading = true;
      this.webUtil
        .getEthereum()
        .then(async (ethereum) => {
          if (ethereum) {
            // ethereum.on('chainChanged', async () =>{
            ethereum.on("networkDidChange", async () => {
              this.getAccountAndLogin();
            });
            // 判断chainId
            let chainId = await window.ethereum.request({
              method: "eth_chainId",
            });
            if (chainId - 0 != this.chainInfo.chainID - 0) {
              this.$alert(
                this.$t("switch_to").replace("%w", this.chainInfo.name)
              ).then(async () => {
                await this.addEthereumChain(this.chainInfo);
                this.loading = false;
              });
            } else {
              this.getAccountAndLogin();
            }
          } else {
            this.noExtension();
          }
        })
        .catch(() => {
          this.noExtension();
        });
    },
    async addEthereumChain(chain) {
      let chainId = "0x" + parseInt(chain.chainID).toString(16);
      try {
        return await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: chainId }],
        });
      } catch (switchErr) {
        let params = {
          chainId: chainId,
          chainName: chain.name,
          rpcUrls: [chain.rpc],
          nativeCurrency: null,
        };
        return await window.ethereum.request({
          method: "wallet_addEthereumChain",
          params: [params],
        });
      }
    },
    async getAccountAndLogin() {
      let accounts;
      try {
        accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
      } catch (e) {
        this.loading = false;
        return this.$alert(this.$t("please_create_account"));
      }
      let account = accounts[0];
      this.setAccount(account);
      this.webUtil.setSession("ledger_flag", false);
      this.loading = false;
    },
    ledgerLogin() {
      try {
        this.ledgerLoading = true;
        TransportWebUSB.create()
          .then((transport) => {
            let eth = new Eth(transport);
            eth.getAddress(this.path).then((response) => {
              if (response && response.address) {
                this.setAccount(response.address);
                this.webUtil.setSession("ledger_flag", true);
              }
              this.ledgerLoading = false;
            });
          })
          .catch((e) => {
            this.ledgerLoading = false;
            return this.$alert(e?.message);
          });
      } catch (e) {
        this.ledgerLoading = false;
        return this.$alert(this.$t("ledger_lock"));
      }
    },
    // 没有安装插件
    noExtension() {
      this.loading = false;
      this.$confirm({
        content: this.$t("noMathExtension"),
        yesText: "Download",
        noText: "Close",
      })
        .then((success) => {
          if (success) {
            window.open("https://mathwallet.org");
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
a.btn {
  width: 45%;
}
.ledger-login a.btn {
  margin-top: 20px;
}
a.btn.disabled {
  opacity: 0.5;
}
</style>
